import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/investigaciones-clinicas-mdr")({
  head: () => buildRouteHead("/es/investigaciones-clinicas-mdr", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/clinical-solutions", replace: true });
  },
});
